import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { ComponentOutputStatus } from '../../normalizzazione/component-output-status';
import { ContattoDTO } from '../../models/contatto-dto';
import { DomicilioDTO } from '../../models/domicilio-dto';
import { ComponentReducer } from '../../utils/component-reducer';
import { DatiRichiedenteDTO } from '../../models/dati-richiedente-dto';
import { PersonaFisica } from '../../models/portale/persona-fisica-model';
import { DatiPersonaFisica } from '../../models/portale/dati-persona-fisica';
import { Indirizzo } from '../../models/portale/indirizzo';
import { Recapito } from '../../models/portale/recapito';
import { Domicilio } from '../../models/portale/domicilio';

@Component({
	selector: 'lib-richiedente',
	templateUrl: './richiedente.component.html',
	styleUrls: ['./richiedente.component.css']
})
export class RichiedenteComponent implements OnInit {

	form: FormGroup;

	@Input()
	datiRichiedente: DatiRichiedenteDTO;

	@Input()
	personaFisica$: Observable<PersonaFisica>;

	@Output()
	nextStep: EventEmitter<DatiRichiedenteDTO> = new EventEmitter<DatiRichiedenteDTO>();

	@Output()
	salvaBozza: EventEmitter<DatiRichiedenteDTO> = new EventEmitter<DatiRichiedenteDTO>();

	datiPersonaFisica$: Observable<DatiPersonaFisica>;
	residenza$: Observable<Indirizzo>;
	recapiti$: Observable<Array<Recapito>>;
	domicili$: Observable<Array<Domicilio>>;

	changesPersonaFisica$ = new Subject<
		ComponentOutputStatus<(value: DatiRichiedenteDTO) => void>
	>();

	changesResidenza$ = new Subject<
		ComponentOutputStatus<(value: DatiRichiedenteDTO) => void>
	>();

	changesRecapito$ = new Subject<
		ComponentOutputStatus<(value: DatiRichiedenteDTO) => void>
	>();

	changesDomicilio$ = new Subject<
		ComponentOutputStatus<(value: DatiRichiedenteDTO) => void>
	>();

	//isFormValid: boolean;

	direction: string = "only-forward";

	isFinal: boolean = false;

	isDomicilioElettoValid: boolean = false;

	domicilioElettoSub: Subscription;

	isDichiaranteValid: boolean;

	constructor() { }

	ngOnInit(): void {

		//console.log('[DatiRichiedenteDTO]', this.datiRichiedente);

		this.form = new FormGroup({});
		let valid = true;

		if (!this.datiRichiedente) {
			this.initRichiedente();
			valid = false;
		}

		const dichiarante$ = ComponentReducer.reducer4(
			this.changesPersonaFisica$,
			this.changesResidenza$,
			this.changesRecapito$,
			this.changesDomicilio$,
			(dich) => {
				// console.log("[dich]", dich);
				// console.log("[hasSelezionatoDomicilio]", dich.domicilio.hasSelezionatoDomicilio);
				let isValid: boolean;
				if (!dich.domicilio.hasSelezionatoDomicilio && dich.domicilio.hasSelezionatoDomicilio != undefined) {
					isValid = dich.contatto != null;
				} else {
					isValid = dich.domicilio != null;
				}
				//TODO
				// this.isDomicilioElettoValid
				// 	? dich.domicilio != null // se il domicilio non è validato controlla se diverso da null se lo è torna false altrimenti true.
				// 	: true // se già è validato torna true.
				// return (
				// 	dich.contatto != null ||  // basterebbe uno dei due diverso da null per tronare false
				// 	this.isDomicilioElettoValid
				// );
				valid = isValid
				return isValid;
			},
			ComponentOutputStatus.of(valid, this.datiRichiedente) // normalizzazione componente dichiarante
		);

		dichiarante$.subscribe((dichiarante) => {
			console.log("[RichiedenteComponent] datiRichiedente", dichiarante);
			//TODO
			//this.isFormValid = dichiarante.status;
			if (dichiarante.output.domicilio.hasSelezionatoDomicilio == false) {
				//TODO
				// this.isDichiaranteValid = dichiarante.output.infoContatto.email != null || dichiarante.output.infoContatto.pec != null;
				this.isDichiaranteValid = this.hasSelecteDichiarante(dichiarante);
			} else {
				//TODO
				// this.isDichiaranteValid = (dichiarante.output.infoContatto.email != null || dichiarante.output.infoContatto.pec != null) &&
				// 	(dichiarante.output.domicilio.idDomicilioSelezionato != null) &&
				// 	(dichiarante.output.domicilio.contatto.email != null || dichiarante.output.domicilio.contatto.pec != null);
				this.isDichiaranteValid = this.hasSelecteDichiaranteAnd(dichiarante);
			}
		});

		//TODO
		//--------viene passato dall'input--------//
		// this.personaFisica$ = this.personaFisicaService.getPersonaFisicaUtente$()
		//   .pipe(shareReplay());

		this.datiPersonaFisica$ = this.personaFisica$
			.pipe(pluck("datiPersonaFisica"));

		this.residenza$ = this.personaFisica$
			.pipe(pluck("residenza"));

		this.recapiti$ = this.personaFisica$
			.pipe(
				pluck("recapiti"),
				map(recapiti => recapiti || [])
			);

		this.domicili$ = this.personaFisica$
			.pipe(pluck("domicili"));

	}

	public recapitiReady(recapitiStatus: ComponentOutputStatus<ContattoDTO>) {
		// console.log('[racapitiStatus]', recapitiStatus);
		this.changesRecapito$.next(
			recapitiStatus.mapValue((contatto) => (dich: DatiRichiedenteDTO) => {
				return dich.contatto = contatto;
			})
		);
	}

	public domiciliReady(domiciliStatus: ComponentOutputStatus<DomicilioDTO>) {
		// console.log('[domiciliStatus]', domiciliStatus);
		this.changesDomicilio$.next(
			domiciliStatus.mapValue((domicilio) => (dich: DatiRichiedenteDTO) => {
				dich.domicilio = domicilio;
				//TODO: fix
				// (this.isDomicilioElettoValid = domicilio.idDomicilioSelezionato != null);
			})
		);
	}

	initRichiedente() {
		this.datiRichiedente = new DatiRichiedenteDTO();
		this.datiRichiedente.contatto = new ContattoDTO();
		//TODO
		this.datiRichiedente.domicilio = new DomicilioDTO();
		this.datiRichiedente.domicilio.contatto = new ContattoDTO();
		this.datiRichiedente.domicilio.idDomicilioSelezionato = null;
	}

	forward(_) {
		this.nextStep.emit(this.datiRichiedente);
	}

	complete(_) { }

	onSalvaBozza(_) {
		this.salvaBozza.emit(this.datiRichiedente);
	}

	ngOnDestroy(): void {
		if (this.domicilioElettoSub) {
			this.domicilioElettoSub.unsubscribe();
		}
	}

	public hasSelecteDichiarante(dichiarante): boolean {
		return dichiarante.output.contatto.email != null || dichiarante.output.contatto.pec != null;;
	}

	public hasSelecteDichiaranteAnd(dichiarante): boolean {
		return this.hasSelecteDichiarante(dichiarante) &&
			(dichiarante.output.domicilio.idDomicilioSelezionato != null) &&
			(dichiarante.output.domicilio.contatto.email != null || dichiarante.output.domicilio.contatto.pec != null);
	}
}
